export default __webpack_public_path__ + "static/media/Floral.cb872691.png";